import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Loading from 'components/Loading';
import ActionCounter from 'components/ActionCounter';
import PlayerEchoes from './components/PlayerEchoes';
import PlayerFate from './components/PlayerFate';

export function PlayerStats({ actions }) {
  if (!actions) {
    return <Loading spinner />;
  }

  return (
    <ul className="items items--list">
      <li className="item">
        <ActionCounter />
      </li>
      <PlayerFate />
      <PlayerEchoes />
    </ul>
  );
}

PlayerStats.displayName = 'PlayerStats';

PlayerStats.propTypes = {
  actions: PropTypes.shape({
    actions: PropTypes.number,
    actionBankSize: PropTypes.number,
  }),
};

PlayerStats.defaultProps = {
  actions: undefined,
};

const mapStateToProps = state => ({
  actions: state.actions,
});

export default withRouter(connect(mapStateToProps)(PlayerStats));
